export default __webpack_public_path__ + "static/media/Abuja3.f703fbd3.jpg";